import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  type SelectProps
} from '@mui/material'
import React from 'react'

import {
  type ThirdPartyExternalIntegration,
  THIRD_PARTY_SELECT_OPTIONS
} from 'components/rbac-settings/teams/integrations/third-party/third-party-account-integrations-utils'

const LABEL = 'Third Party'
const LABEL_ID = 'third-party-select-menu'

export function ThirdPartySelectMenu({
  selected,
  onSelect
}: {
  selected: ThirdPartyExternalIntegration
  onSelect: (integrationName: ThirdPartyExternalIntegration) => void
}) {
  const handleOnChange: SelectProps<ThirdPartyExternalIntegration>['onChange'] =
    (event) => {
      const selectedDate = event.target.value
      onSelect(selectedDate as ThirdPartyExternalIntegration)
    }

  return (
    <FormControl sx={{ maxWidth: 260 }}>
      <InputLabel id={LABEL_ID}>{LABEL}</InputLabel>
      <Select
        label={LABEL}
        labelId={LABEL_ID}
        value={selected ?? ''}
        onChange={handleOnChange}
      >
        {THIRD_PARTY_SELECT_OPTIONS.map((menuItem) => {
          return (
            <MenuItem key={menuItem.label} value={menuItem.value}>
              {menuItem.label}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}
